document.querySelectorAll('.SelectCityStep>div[data-step-trigger]').forEach((el) => {
    el.addEventListener('click', () => {
        let stepDiv = el.closest('.ModalSelectCity__step');

        for (const el of stepDiv.parentElement.children) el.classList.remove('ModalSelectCity__step--active');
        (stepDiv.nextElementSibling || stepDiv).classList.add('ModalSelectCity__step--active');

        if(stepDiv.nextElementSibling && window.$isMobile) {
            stepDiv.nextElementSibling.querySelector('.ModalSelectCity__title').innerHTML = el.innerHTML;
        }

        stepDiv.querySelectorAll('.active').forEach((el) => el.classList.remove('active'));
        el.classList.add('active');
        while (stepDiv = stepDiv.nextElementSibling) {
            stepDiv.querySelectorAll('*[data-step-active]').forEach((el) => {
                el.removeAttribute('data-step-active');
            });
        }
        const container = document.querySelector(`.SelectCityStep[data-step="${el.dataset.stepTrigger}"]`);
        if (container) {
            container.setAttribute('data-step-active', '');
        }
        else {
            const modalEl = el.closest('.modal');
            modalEl.dispatchEvent(new CustomEvent('select', {detail: el}));
            closeModal(modalEl);
        }
    }, { passive: true });
});

document.querySelectorAll('.ModalSelectCity__back').forEach((el) => {
    el.addEventListener('click', () => {
        let stepDiv = el.closest('.ModalSelectCity__step');
        stepDiv.classList.remove('ModalSelectCity__step--active');
        stepDiv.previousElementSibling.classList.add('ModalSelectCity__step--active');
    }, { passive: true });
})

//document.querySelectorAll('.SelectCityStep:first-of-type>div:first-child').forEach((el) => el.click());
